import PropTypes from 'prop-types';

export const PromotionShape = PropTypes.shape({
  type: PropTypes.string,
  summary: PropTypes.string,
});
